module.exports = {"page":"Contact","metaTitle":"108 Leonard | Modern Design Residences in Downtown New York","metaDescription":"Complete your information and we will contact you."}


//////////////////
// WEBPACK FOOTER
// ./src/components/data/contact.json
// module id = 778
// module chunks = 0